import { useEffect } from 'react'
import { useRouter } from 'next/router'
import StaticSeo from 'src/seo/components/StaticSeo'
import ContextProvider from 'lib/context'
import SessionGuard from '@components/session/SessionGuard'
import UserChangeListener from '@components/session/UserChangeListener'
import GuestWatchMerge from '@components/session/GuestWatchMerge'
import RouteChangeProgress from '@components/progress/RouteChangeProgress'
import Notice from '@components/shared/notice/Notice'
import useHideCookieBotWidget from '@hooks/useHideCookieBotWidget'
// import { CookieConsent } from '@components/Cookies'
// import OneTimeUserMessages from '@components/OneTimeUserMessages'
// import OneTimeMessageForLoggedInDealers from '@components/OneTimeMessageForLoggedInDealers'
// import OneTimeUserCardReminder from '@components/OneTimeUserCardReminder'
import unregister from '@utils/sw/unregister'
import 'styles/globals.css'
import { AcceptRecentRegulationsModal } from 'src/app/AcceptRecentRegulationsModal'
import { manrope, saira } from 'src/app/fonts'

const UNREGISTER_ALL_SERVICE_WORKERS = true

const SPL = ({ Component, pageProps }) => {
  const router = useRouter()
  // RouteChangeProgress chowa CookieBotWidget dopiero po zmianie trasy —
  // przy wejściu z paska adresu / po odświeżeniu żaden routeChange* się nie
  // zdarza, więc trzeba spróbować też przy pierwszym montowaniu drzewa.
  useHideCookieBotWidget(router.pathname)

  useEffect(() => {
    if (UNREGISTER_ALL_SERVICE_WORKERS) unregister()
  }, [])

  return <>
    {/* Pages Router nie ustawia klas na <html>, więc zmienne fontów trafiają do :root tutaj. */}
    <style jsx global>{`
      :root {
        --font-manrope: ${manrope.style.fontFamily};
        --font-saira: ${saira.style.fontFamily};
      }
    `}</style>
    <div>
        <StaticSeo />
      <ContextProvider>
        {/* <OneTimeUserMessages messages={[
          OneTimeMessageForLoggedInDealers,
          OneTimeUserCardReminder,
        ]} /> */}
        {/* <CookieConsent /> */}
        <SessionGuard />
        <UserChangeListener />
        <RouteChangeProgress />
        <Component {...pageProps} />
        <Notice />
        <GuestWatchMerge />
        <AcceptRecentRegulationsModal />
      </ContextProvider>
    </div>
  </>
}

export default SPL
